import React, { useState } from 'react';
import {Container,Row,Col,Button} from 'react-bootstrap';
import moment from "moment";
import "moment/locale/es";
import { Form } from 'react-bootstrap';
moment.locale("mx");

export const Nube = () => {

  const [state,setState] = useState({
    search_input: '',
  })
  return(
    <div className="container-fluid">
      <div className="ws-main-container">

        <div className="ws-tab-container pb-3">
          <div className="row mt-3">
            <Col xs={6}>
              <Form onSubmit={ (e) => e.preventDefault() }>
                <Form.Group className="group-search">
                  <i className="bi bi-search pe-2"></i>
                  <Form.Control 
                  type="search" 
                  className="ws-input-search" 
                  placeholder="Buscar archivo en la nube" 
                  value={state.search_input}
                  onChange={ (e) => setState({ ...state, search_input : e.target.value}) }
                  />
                </Form.Group>
              </Form>
            </Col>
            <Col xs={3}>
              <Form onSubmit={ (e) => e.preventDefault() }>
                <Form.Group>
                  <Form.Select>
                    <option value="clientes">Clientes</option>
                    <option value="polizas">Contratos</option>
                  </Form.Select>
                </Form.Group>
              </Form>
            </Col>  
            <Col xs={3}>
              <Button className="ws-btn-blue-2"><i className='bi bi-search'></i> Buscar</Button>
            </Col>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="ws-box-container">
              {/* {<div className="ws-loader-container"><div className="spinner"></div></div>} */}
              <h4>Nube</h4>
              <Container>
                <Row>
                  <Col xs={12} className="d-flex flex-column justify-content-center align-items-center mt-4 mb-4">
                    <i className="bi bi-cloud ws-icon-info-container"></i>
                    <p className="ws-text-info-container">Busca cualquier archivo en la nube</p>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) 
}